module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sl-switcher"
  }, _vm._l((_vm.switchArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "sl-btn",
      class: {
        'sl-btn-active': index === _vm.switchActive
      },
      on: {
        "click": function($event) {
          _vm.handleSwitcher(index)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66e290f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/sl-switcher.vue
// module id = 1115
// module chunks = 1